var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Basket',{attrs:{"payFunc":_vm.payFunc,"toBasketFunc":_vm.toBasketFunc}})
}
var staticRenderFns = []

export { render, staticRenderFns }